<template>
  <section :class="{ cabecalho: true, resumo: $route.name != 'home' }">
    <carousel
      :per-page="1"
      :navigate-to="0"
      :autoplay="true"
      :loop="true"
      :navigationEnabled="true"
      pagination-position="bottom-overlay"
    >
      <slide v-for="(banner, index) in banners" :key="index">
        <a :href="banner.link" class="item">
          <div :style="{ backgroundImage: `url(${banner.imagem})` }"></div>
        </a>
      </slide>
    </carousel>

    <div class="barra">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-3 pt-3 d-flex justify-content-center">
            <router-link :to="{ name: 'home' }">
              <img src="/images/logo.png" id="logo" />
            </router-link>
          </div>

          <div class="col-12 col-md-5 d-none d-md-block">
            <nav>
              <ul>
                <li>
                  <router-link :to="{ name: 'home' }">Home</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'home', hash: '#sobre' }"
                    >Sobre</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'home', hash: '#acoes' }"
                    >Ações</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'home', hash: '#noticias' }"
                    >Notícias</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'home', hash: '#contato' }"
                    >Contato</router-link
                  >
                </li>
              </ul>
            </nav>
          </div>

          <div class="col-2" v-if="false">
            <form action="#">
              <i class="icon-search" />
              <input
                type="text"
                name="s"
                id="s"
                class="search"
                placeholder="Faça uma busca"
                v-model="s"
              />
            </form>
          </div>

          <div class="col-10 offset-1 col-md-4 offset-md-0 social">
            <a
              href="https://www.instagram.com/carloshumbertobc/"
              target="_blank"
              ><img src="/images/icon-instagram.png"
            /></a>
            <a href="https://twitter.com/CarlosH_SC" target="_blank"
              ><img src="/images/icon-twitter.svg"
            /></a>
            <a href="https://www.facebook.com/carloshumbertobc" target="_blank"
              ><img src="/images/icon-facebook.svg"
            /></a>
            <a
              href="https://www.youtube.com/channel/UCksBOCHQt5MMNKBEcC91YPA"
              target="_blank"
              ><img src="/images/icon-youtube.svg"
            /></a>
            <!--<a href="#"><img src="/images/icon-linkedin.svg" /></a> -->
            <a
              href="https://chat.whatsapp.com/DaDaI30Q1EA1OHLmDlw3qP"
              target="_blank"
              title="Entre agora do Deputado Carlos Humberto!"
              class="btn btn-whatsapp align-items-center ms-3 btn-sm btn-md-auto"
            >
              <img src="/images/icon-whatsapp.svg" /> Entre no Grupo
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        {
          link: "",
          imagem: "/images/banners/banner2023.png",
        },
      ],
      errorMessage: null,
      s: null,
    };
  },
  mounted: function () {
    //this.carregar();
  },
  methods: {
    async carregar() {
      var $this = this;
      $this.errorMessage = "";
      $this.$sdk
        .get("banners/home")
        .then((ret) => {
          $this.banners = ret;
        })
        .catch((err) => {
          $this.errorMessage = err;
        });
    },
  },
};
</script>

<style lang="css">
.btn-whatsapp {
  background-color: #25d366;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.btn-whatsapp img {
  width: 25px;
  height: 25px;
}

/* Estilos para dispositivos móveis */
@media (max-width: 767.98px) {
  .btn-whatsapp {
    padding: 2px 10px; /* Remove o padding no mobile */
  }

  .btn-whatsapp img {
    width: 16px;
    height: 16px; /* Ajusta o tamanho da imagem no mobile */
  }
}

.btn-whatsapp:hover {
  background-color: #1dbf57;
  color: white;
  text-decoration: none;
}
</style>
